let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4K0PB")).then(() => parcelRequire('cdYRp'));